import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TeamMembershipService } from './team-membership.service';

/**
 * Runs alongside AngularFire's AuthGuard (router guards in a canActivate array are
 * evaluated concurrently). Accounts coming from the other applications in this
 * Firebase project belong to no team here and must be sent to the no-access page
 * instead of an empty app shell. TeamMembershipService waits for auth restoration
 * itself, so this does not depend on AuthGuard resolving first.
 */
export const teamMemberGuard: CanActivateFn = async () => {
    const router = inject(Router);
    const membership = inject(TeamMembershipService);

    return (await membership.hasTeam()) ? true : router.createUrlTree(['/no-access']);
};
